module.exports = "<p class=\"f_eb message\"> {{if endType === 'end' || endType === ''}} 다음 검색이 분석한 최적의 검색결과를 확인하셨습니다. 원하시는 결과를 못 얻으셨다면 검색어를 변경해서 다시 검색해보시기 바랍니다. {{else endType === 'dup_end'}} 효과적으로 검색결과를 확인하실 수 있도록 중복된 이미지는 생략되었습니다. 원하시는 결과를 못 얻으셨다면 검색어를 변경해서 다시 검색해보시기 바랍니다. {{/if}}</p> <a class=\"btn_top\"><span class=\"txt_top\">맨위로<span class=\"ico_rwd\"></span></span></a>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/IIM/core/templates/no_image_msg.hbs
 ** module id = 27
 ** module chunks = 0 1
 **/